import { User } from "../Model/User";
export class UsersService {
    constructor(apiService) {
        this.apiService = apiService;
    }
    async getUser(userId) {
        const hasNetwork = localStorage.getItem('hasNetwork') === 'true' ? true : false;
        if (hasNetwork) {
            const response = await this.apiService.get(`user/${userId}`);
            if (!response.ok) {
                throw new Error('Ha ocurrido un error al obtener el usuario.');
            }
            const content = await response.json();
            const dataString = JSON.stringify(content);
            localStorage.setItem(`${userId}`, dataString);
            return this.createUser(content);
        }
        const user = JSON.parse(localStorage.getItem(`${userId}`));
        if (!user) {
            throw new Error('Ha ocurrido un error al obtener el usuario.');
        }
        return this.createUser(user);
    }
    async userActualIsForeman(userId) {
        const hasNetwork = localStorage.getItem('hasNetwork') === 'true' ? true : false;
        if (hasNetwork) {
            const response = await this.apiService.get(`user/foreman/${userId}`);
            if (!response.ok) {
                throw new Error('Ha ocurrido un error al obtener el foreman.');
            }
            const content = await response.json();
            const dataString = JSON.stringify(content);
            localStorage.setItem(`userActualIsForeman`, dataString);
            return content;
        }
        const foreman = JSON.parse(localStorage.getItem(`userActualIsForeman`));
        if (!foreman) {
            throw new Error('Ha ocurrido un error al obtener el foreman.');
        }
        return foreman;
    }
    async getUsers(offset, limit) {
        const hasNetwork = localStorage.getItem('hasNetwork') === 'true' ? true : false;
        if (hasNetwork) {
            const response = await this.apiService.get(`users/${offset}/${limit}`);
            if (!response.ok) {
                throw new Error('Ha ocurrido un error al obtener los usuarios.');
            }
            const content = await response.json();
            const dataString = JSON.stringify(content);
            localStorage.setItem(`usersList`, dataString);
            return content.map((data) => this.createUser(data));
        }
        const users = JSON.parse(localStorage.getItem(`usersList`));
        if (!users || users.length === 0) {
            throw new Error('Ha ocurrido un error al obtener los usuarios.');
        }
        return users.map((data) => this.createUser(data));
    }
    async getOperators(offset, limit) {
        const hasNetwork = localStorage.getItem('hasNetwork') === 'true' ? true : false;
        if (hasNetwork) {
            const response = await this.apiService.get(`operators/${offset}/${limit}`);
            if (!response.ok) {
                throw new Error('Ha ocurrido un error al obtener los usuarios.');
            }
            const content = await response.json();
            const dataString = JSON.stringify(content);
            localStorage.setItem(`users-operators`, dataString);
            return content.map((data) => this.createUser(data));
        }
        const users = JSON.parse(localStorage.getItem(`users-operators`));
        if (!users || users.length === 0) {
            throw new Error('Ha ocurrido un error al obtener los usuarios.');
        }
        return users.map((data) => this.createUser(data));
    }
    createUser(data) {
        return new User(data.id, data.rol_id, data.foreman, data.name, data.image);
    }
}
